import { ReactNode } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { surface } from 'modules/minimal-ui-theme';
import { StyledCard } from './styledComponents';

interface Props {
  children: ReactNode;
  backgroundColor?: string;
  sx?: SxProps;
}

export const InfoCard = ({ children, backgroundColor, sx }: Props) => {
  const { bg, text } = surface.info;

  return (
    <StyledCard sx={{ backgroundColor: backgroundColor ?? bg, ...sx }}>
      <InfoIcon sx={{ color: text }} />
      <Box sx={{ '& p': { color: text } }}>{children}</Box>
    </StyledCard>
  );
};
